// 47264 R-BZ Q18 (owner 2026-10-22) — the who / when / channel render HISTORY of ONE issued document, opened ON DEMAND from the "Print history" action. It must NEVER appear on the
// document body / print / PDF / screenshot, so it lives in its own shell record-drawer (eyebrow, title, .gtable zebra, Close-left footer), not under the sheet. Read-only; fed by
// GET /api/documents/:kind/:id/print-log. Only PDF renders decide Original vs Reprint; a view row shows "Viewed" (views never count/mark).
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import DrawerFrame from '../../shell/drawer/DrawerFrame';
import DrawerHeader from '../../shell/drawer/DrawerHeader';
import DrawerFooter from '../../shell/drawer/DrawerFooter';

export default function DocPrintLogDrawer({ kind, id, title, onClose }) {
  const { t, i18n } = useTranslation('common');
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!kind || !id) return undefined;
    let alive = true;
    api.getDocPrintLog(kind, id).then(r => alive && setRows(r.rows || [])).catch(() => alive && setRows([]));
    return () => { alive = false; };
  }, [kind, id]);
  const when = (iso) => { try { return new Date(iso).toLocaleString(i18n.language); } catch { return iso; } };
  const channel = (c) => (c === 'pdf' ? t('doc.plPdf') : c === 'view' ? t('doc.plView') : c);
  const copy = (r) => (r.channel === 'view' ? t('doc.plViewed') : r.is_reprint ? t('doc.plReprint') : t('doc.plFirst'));
  return (
    <DrawerFrame size="standard" onClose={onClose} label={t('doc.printLog')} testId="doc-print-log-drawer">
      <DrawerHeader eyebrow={t('doc.printLog')} title={title || t('doc.printLog')} onClose={onClose} />
      <div className="dr-body">
        <div className="hint" style={{ marginBottom: 8 }}>{t('doc.printLogHint')}</div>
        {rows == null ? <div className="hint">{t('loading')}</div>
          : !rows.length ? <div className="hint">{t('doc.plNone')}</div> : (
            <div className="field full">
              <table className="gtable zebra" style={{ width: '100%' }} data-testid="doc-print-log-table">
                <thead><tr><th>{t('doc.plWhen')}</th><th>{t('doc.plWho')}</th><th>{t('doc.plChannel')}</th><th>{t('doc.plCopy')}</th></tr></thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>
                      <td>{when(r.rendered_at)}</td>
                      <td>{r.rendered_by_email || '—'}</td>
                      <td>{channel(r.channel)}{r.lang ? ` · ${String(r.lang).toUpperCase()}` : ''}</td>
                      <td>{copy(r)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </div>
      <DrawerFooter onClose={onClose} />
    </DrawerFrame>
  );
}
